/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Panel_LabelInputs */

const en_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick tools panel`)
};

const fr_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panneau QuickTools`)
};

const de_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellwerkzeug-Panel`)
};

const it_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pannello degli strumenti rapidi`)
};

const ru_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель быстрых инструментов`)
};

const es_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de herramientas rápidas`)
};

const zh_cn2_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速工具面板`)
};

const ja_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックツールパネル`)
};

const hi_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्वरित उपकरण पैनल`)
};

const pt_pt2_quicktools_panel_label = /** @type {(inputs: Quicktools_Panel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de ferramentas rápidas`)
};

/**
* | output |
* | --- |
* | "Quick tools panel" |
*
* @param {Quicktools_Panel_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_panel_label = /** @type {((inputs?: Quicktools_Panel_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Panel_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_panel_label(inputs)
	if (locale === "de") return de_quicktools_panel_label(inputs)
	if (locale === "it") return it_quicktools_panel_label(inputs)
	if (locale === "ru") return ru_quicktools_panel_label(inputs)
	if (locale === "es") return es_quicktools_panel_label(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_panel_label(inputs)
	if (locale === "ja") return ja_quicktools_panel_label(inputs)
	if (locale === "hi") return hi_quicktools_panel_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_panel_label(inputs)
	return en_quicktools_panel_label(inputs)
});